import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClinicWebPartnerReferrerAuditOfAppointment } from 'app/shared/portal/models/clinic-web-partner-referrer-audit-of-appointment.model';
import { ClinicWebPartnerReferrerAuditOfClientProfile } from 'app/shared/portal/models/clinic-web-partner-referrer-audit-of-client-profile.model';
import { ClinicWebPartnerReferrerAuditOfVisit } from 'app/shared/portal/models/clinic-web-partner-referrer-audit-of-visit.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class WebPartnerAuditHttpService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getWebPartnerReferrerCanBookAnonymously(partnerToken: string): Observable<boolean> {
    const url = `${this.baseUrl}clinicwebpartnerreferrer/${partnerToken}/canbbokanonymously`;
    return this.http.get<boolean>(url);
  }

  insertWebPartnerReferrerAuditOfVisit(
    partnerToken: string
  ): Observable<ClinicWebPartnerReferrerAuditOfVisit> {
    const url = `${this.baseUrl}clinicwebpartnerreferreraudits/${partnerToken}/visit`;
    return this.http.post<ClinicWebPartnerReferrerAuditOfVisit>(url, {});
  }

  insertWebPartnerReferrerAuditOfClientProfile(
    partnerToken: string,
    clientId: number
  ): Observable<ClinicWebPartnerReferrerAuditOfClientProfile> {
    const url = `${this.baseUrl}clinicwebpartnerreferreraudits/${partnerToken}/clientprofilecreation/${clientId}`;
    return this.http.post<ClinicWebPartnerReferrerAuditOfClientProfile>(url, {});
  }

  insertWebPartnerReferrerAuditOfAppointment(
    partnerToken: string,
    appointmentId: number
  ): Observable<ClinicWebPartnerReferrerAuditOfAppointment> {
    const url = `${this.baseUrl}clinicwebpartnerreferreraudits/${partnerToken}/appointment/${appointmentId}`;
    return this.http.post<ClinicWebPartnerReferrerAuditOfAppointment>(url, {});
  }
}
